<app-base-overlay [title]="title()" [showActionsBorder]="true">
  <div body class="flex min-h-0 flex-col gap-3">
    <lib-signal-text-field
      label=""
      placeholder="Search…"
      [value]="search()"
      [debounceValueChange]="true"
      (valueChange)="onSearchChange($event)" />

    <div
      #listRoot
      class="max-h-[22rem] min-h-[12rem] overflow-y-auto rounded-xl border border-slate-200"
      (scroll)="onListScroll($event)">
      @if (isLoading()) {
        <p class="py-10 text-center text-sm text-slate-500">Loading…</p>
      } @else if (isEmpty()) {
        <p class="py-10 text-center text-sm text-slate-500">No matching items.</p>
      } @else {
        <ul class="m-0 list-none p-0">
          @for (item of listItems(); track item.id) {
            <li>
              <button
                type="button"
                class="flex w-full cursor-pointer flex-col gap-0.5 border-0 border-b border-slate-100 bg-transparent px-3 py-2.5 text-left transition last:border-b-0 hover:bg-slate-50"
                [class.bg-primary-50]="selectedId() === item.id"
                (click)="selectItem(item)">
                <span class="truncate text-sm font-medium text-slate-900">
                  {{ item.display }}
                </span>
                @if (item.secondaryDisplay) {
                  <span class="truncate text-xs text-slate-500">
                    {{ item.secondaryDisplay }}
                  </span>
                }
              </button>
            </li>
          }
        </ul>
        @if (isLoadingMore()) {
          <p class="py-3 text-center text-xs text-slate-400">Loading more…</p>
        }
      }
      <div
        #sentinel
        class="h-px w-full shrink-0"
        [class.hidden]="isLoading() || isEmpty()"
        aria-hidden="true"></div>
    </div>
  </div>

  <div actions class="flex flex-wrap justify-between gap-3">
    <div>
      @if (canClear()) {
        <lib-signal-button
          appearance="outline"
          [fullWidth]="false"
          (clicked)="clearSelection()">
          Clear
        </lib-signal-button>
      }
    </div>
    <lib-signal-button
      appearance="outline"
      [fullWidth]="false"
      (clicked)="cancel()">
      Cancel
    </lib-signal-button>
  </div>
</app-base-overlay>
